import { viewJobNativeModule } from "./ViewJobNativeModule";
import { callPromiseAssert } from "../../shared/util/callPromiseAssert";

export function httpGetJson<T>(url: string): Promise<T> {
  return callPromiseAssert(viewJobNativeModule()?.httpGetJson<T>, "httpGetJson", url);
}
